import client from './client';

const Messages = {
  getMessages(anketId) {
    return client.get(`/ankets/${anketId}/messages`);
  },
  sendMessage(anketId, message) {
    return client.post(`/ankets/${anketId}/messages`, message);
  },
};

export default Messages;
